import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {inject} from '@angular/core';
import {tap, timeout} from 'rxjs';
import {Router} from "@angular/router";
import {APP_VERSION} from "../../../version";

let triggered = false;

export const versionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  let obs$ = next(req);

  // Apply timeout only for non-export requests
  if (!req.url.includes('/export')) {
    obs$ = obs$.pipe(timeout(20000));
  }

  return obs$.pipe(
    // prevent requests from “hanging” indefinitely when the server is down
    tap(event => {
      if (!(event instanceof HttpResponse)) return;

      const backendVersion = event.headers.get('X-App-Version');
      if (!backendVersion) return;

      const versionsMatch = backendVersion === APP_VERSION;

      // 🚨 Recovery: we’re in /maintenance and versions match
      if (router.url === '/maintenance' && versionsMatch) {
        const lastUrl = localStorage.getItem('lastUrl') || '/';
        triggered = false;
        localStorage.removeItem('lastUrl');
        router.navigateByUrl(lastUrl).then(() => {
          location.reload();
        });
        return;
      }

      if (backendVersion !== APP_VERSION && !triggered) {
        localStorage.setItem(
          'lastUrl',
          router.url.endsWith('/maintenance') ? '/' : router.url
        );
        triggered = true;
        router.navigate(['/maintenance']);
      }
    }),
  );
};
